// application components goes here
import { ASSET_DETAILS, CAMPAIGNS_LIST, EMAIL_LIST, GET_CAMPAIGNS_NAMES_ONLY } from "constants/types";
import { getEditionArticles } from "modules/Campaigns/Edition/actions";
import { createNewCampaignSerialize, resetAllData } from "modules/Campaigns/utils";
import { setDesignUpdate } from "modules/EmailBrowser/actions";
import { getQueryEmailId } from "modules/EmailBrowser/utils";
import { GLOBAL_ACTION } from "modules/GlobalActions";
import {
  ALL_ARTICLES_IN_EDITION,
  DESIGN,
  DESIGN_PREVIEW,
  GENERATE_PREVIEW,
  GENERATE_RSS,
  SAVING_DESIGN,
} from "../../constants/actionTypes";
import store from "../../store/index";
import {
  authorizeStripoService,
  generateDesignPreviewService,
  generateRSSFeedService,
  getDesignPreviewService,
  getDesignService,
  refreshTextPreviewService,
  saveDesignService,
  updateTextPreviewService,
} from "../Services/DesignService";
import { init_stripo_plugin, rerender_after_save, setTemplate, showLoader } from "./Scripts/DynamicStripo";

// action to disable preview button on Edition Header
export const disablePreviewAction = () => {
  store.dispatch({ type: DESIGN.DISABLE_PREVIEW });
};

// action to enable preview button on Edition Header
export const enablePreviewAction = () => {
  store.dispatch({ type: DESIGN.ENABLE_PREVIEW });
};

// get design html content on load
export const getDesignHTMLService = (
  asset_id: number,
  templateStyleId: number,
  change_template: number,
  callback: any,
  fromDesign: boolean,
  fromPublishPage?: boolean
) => {
  disablePreviewAction(); // action to disable preview button on Edition Header

  // show loader on design page
  // store.dispatch({
  //   type: DESIGN.LOAD,
  //   loader: true,
  // });
  showLoader(true);
  getDesignService(asset_id, templateStyleId, change_template, fromDesign)
    .then((res) => {
      // initialize stripo and it's events
      store.dispatch({
        type: DESIGN.LOAD_SUCCESS,
        payload: res.data,
      });
      designSkeletonLoad();
      if (window.location.pathname.includes("publish") && fromPublishPage) {
        callback(res.data.html_content, res.data.email_content, res.data.css_content);
      }
      init_stripo_plugin(res.data, res.data.template_style_id, callback, enablePreviewAction, false, fromDesign);
      if (window.location.pathname.includes("design")) {
        getEditionArticles(getQueryEmailId());
      }
      setDesignUpdate(false);
      // update state with design data

      // if template changed is true than disable it
      // let templateChanged = store.getState().design.tamplateChanged;
      // if (templateChanged && !fromDesign) templateChangeDisable();
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: DESIGN.LOAD_FAIL,
        payload: [],
      });
    });
};

// save design html content
export const saveDesignHTMLService = (
  data: any,
  url?: string,
  history?: any,
  callback?: any,
  save_as_email?: boolean,
  handleCancel?: any,
  showMessage?: any,
  setToggleDisabled?: any
) => {
  // show loader on design page
  if (!save_as_email) store.dispatch({ type: DESIGN.RESET_DESIGN })
  else{
      store.dispatch({type: SAVING_DESIGN.SAVE_AS_SUCCESS, payload: true})

  }
  return saveDesignService(data)
    .then((res) => {
      store.dispatch({ type: SAVING_DESIGN.LOAD_SUCCESS });
      if(save_as_email){
        store.dispatch({type: SAVING_DESIGN.SAVE_AS_SUCCESS, payload: false})
      }
      designSkeletonLoadSuccess();
      if (res.data.exists) {
        setToggleDisabled(false);
        showLoader(false);
        showMessage(true);
        return;
      } else if (res.data.html) {
        if (window.location.pathname.includes("design")) {
          getEditionArticles(res.data.version_id);
        }
        if (save_as_email) {
          if (!data?.get("campaign_id")) {
            const campaign_data = {
              campaign_name: res.data.campaign_name,
              campaign_id: res.data.campaign_id,
              thumbnails: res.data.thumbnails,
              emails_count: 1,
              last_update: "just now",
              total_contacts: "0",
              total_sent: "0",
              total_delivered: "0",
              total_open: "0",
              total_clicks: "0",
            };
            const serializedCampaign = createNewCampaignSerialize(campaign_data, 1);
            store.dispatch({
              type: CAMPAIGNS_LIST.ADD_NEW,
              payload: serializedCampaign,
            });
            store.dispatch({
              type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
              payload: [
                {
                  campaign_id: res.data.campaign_id,
                  name: res.data.campaign_name,
                },
              ],
              newlyAdded: true,
            });
          } else {
            store.dispatch({
              type: CAMPAIGNS_LIST.UPDATE_ASSET_COUNT,
              campaign_id: res.data.campaign_id,
              add: true,
            });
          }
          store.dispatch({
            type: GLOBAL_ACTION.CLOSE_CREATE_ASSET_SIDEBAR,
          });

          store.dispatch({
            type: EMAIL_LIST.RESET,
            payload: true,
          });
          init_stripo_plugin(
            res.data,
            res.data.template_style_id,
            handleCancel !== undefined ? handleCancel : null,
            null,
            false,
            true
          );
          store.dispatch({
            type: DESIGN.LOAD_SUCCESS,
            payload: res.data,
          });
          callback(false);
          history.push(
            `/campaigns/editionedit/design/?campaign_id=${res.data.asset_id}&email_id=${res.data.version_id}`
          );
        } else {
          let ids =
            res.data?.section?.length > 0
              ? res.data?.section[0].articles?.map((item: any) => item.article_id)
              : [];
          if (ids?.length >= 0) {
            store.dispatch({
              type: ALL_ARTICLES_IN_EDITION.UPDATE_ARTICLES_AND_COUNT,
              payload: { articles_ids: ids },
            });
          }
          // show success message when changed/saved template successfully.
          if (url !== undefined && url !== null) changeTemplateSuccess(url);
          if (url === "change_template") {
            templateChangeEnable();
            init_stripo_plugin(res.data, res.data.template_style_id, callback, enablePreviewAction, false, true);
            // update state with design data
            store.dispatch({
              type: DESIGN.LOAD_SUCCESS,
              payload: res.data,
            });
            store.dispatch({
              type: GENERATE_PREVIEW.UPDATE,
              isUpdated: true,
            });
          }
          // checks if only asset name is saved or
          else if (url !== undefined && url !== null) {
            store.dispatch({
              type: DESIGN.LOAD_SUCCESS,
              payload: res.data,
            });
            if (history) history.push(url);
          } else {
            store.dispatch({
              type: SAVING_DESIGN.SUCCESS,
              save_success_text: "Changes saved successfully!",
            });
            store.dispatch({
              type: DESIGN.LOAD_SUCCESS,
              payload: res.data,
            });
            init_stripo_plugin(res.data, res.data.template_style_id, callback);
            setTimeout(() => {
              store.dispatch({ type: SAVING_DESIGN.RESET });
            }, 3000);
          }
        }
      }
    })
    .catch((err) => {
      console.log(err);
      changeTemplateFail(url);
      store.dispatch({
        type: DESIGN.LOAD_FAIL,
        payload: [],
      });
      if (callback) callback(false);
    });
};

// authorizes stripo with key
export const authorizeStripo = (callback: any) => {
  return authorizeStripoService()
    .then((res) => {
      callback(res.data.message);
    })
    .catch((err) => {
      console.log(err);
      callback(null);
    });
};

export const generateRssFeedLink = () => {
  store.dispatch({ type: GENERATE_RSS.LOAD });
  generateRSSFeedService()
    .then((res) => {
      store.dispatch({
        type: GENERATE_RSS.LOAD_SUCCESS,
        rssLink: res?.data?.keylink,
      });
    })
    .catch((err) => {
      console.log("error in rss feed ", err);
      store.dispatch({ type: GENERATE_RSS.LOAD_FAIL });
    });
};

export const resetRSSFeed = () => store.dispatch({ type: GENERATE_RSS.RESET });

export const getDesignPreview = (asset_id: number, assetType?: string, templateId?: number) => {
  store.dispatch({
    type: DESIGN_PREVIEW.LOAD,
  });
  getDesignPreviewService(asset_id, assetType, templateId)
    .then((res) => {
      store.dispatch({
        type: DESIGN_PREVIEW.LOAD_SUCCESS,
        preview_html: res.data.preview_html,
        preview_text: res.data.preview_text,
        default_preview_text: res.data.preview_text,
      });
    })
    .catch((err) => {
      console.log("design preview : ", err);
      store.dispatch({
        type: DESIGN_PREVIEW.LOAD_FAIL,
        preview_html: "",
        preview_text: "",
        default_preview_text: "",
      });
      // show error alert on frontend
    });
};

export const generateDesignPreview = (
  html_content: string,
  email_html: string,
  cssContent: string,
  campaignId: number,
  assetId: number,
  fromDesign?: boolean
) => {
  store.dispatch({
    type: DESIGN_PREVIEW.LOAD,
  });
  let design = store.getState().design.data;
  design.html = html_content;
  generateDesignPreviewService(campaignId, assetId, html_content, email_html, cssContent, fromDesign)
    .then((res) => {
      store.dispatch({
        type: DESIGN_PREVIEW.LOAD_SUCCESS,
        preview_html: res.data.preview_html,
        preview_text: res.data.preview_text,
        default_preview_text: res.data.preview_text,
      });
      enablePreviewAction();
      // init_stripo_plugin(design, design.template_style_id, null, false, true);
    })

    .catch((err) => {
      console.log("design preview : ", err);
      store.dispatch({
        type: DESIGN_PREVIEW.LOAD_FAIL,
        preview_html: "",
        preview_text: "",
        default_preview_text: "",
      });
      // show error alert on frontend
    });
};

export const updateTextPreview = (asset_id: Number, textPreview: string) => {
  store.dispatch({
    type: DESIGN_PREVIEW.LOAD,
  });
  updateTextPreviewService(asset_id, textPreview)
    .then((res) => {
      store.dispatch({
        type: DESIGN_PREVIEW.UPDATE_PREVIEW_TEXT,
        preview_text: res.data.preview_text,
      });
    })
    .catch((err) => {
      console.log("design preview : ", err);
      store.dispatch({
        type: DESIGN_PREVIEW.LOAD_FAIL,
        preview_html: "",
        preview_text: "",
      });
      // show error alert on frontend
    });
};

export const refreshTextPreview = (asset_id: Number, emailContent: string) => {
  store.dispatch({
    type: DESIGN_PREVIEW.LOAD,
  });
  refreshTextPreviewService(asset_id, emailContent)
    .then((res) => {
      store.dispatch({
        type: DESIGN_PREVIEW.UPDATE_PREVIEW_TEXT,
        preview_text: res.data.preview_text,
      });
    })
    .catch((err) => {
      console.log("design preview : ", err);
      store.dispatch({
        type: DESIGN_PREVIEW.LOAD_FAIL,
        preview_text: "",
      });
      // show error alert on frontend
    });
};

export const setMissingLinkErrorOnDesign = (value: boolean) => {
  store.dispatch({ type: DESIGN.SET_MISSING_LINK_ERROR, missingLinkError: value });
};

export const resetDesignPreview = () => {
  store.dispatch({ type: DESIGN_PREVIEW.RESET });
};

// export const sortRightArticles = (articles: any[], curated: any[]) => {
//   store.dispatch({ type: DESIGN.SET_ARTICLES_LIST, articles, curated });
// };

// export const sortLoading = (state: boolean) => {
//   store.dispatch({ type: DESIGN.SET_ARTICLES_LIST_LOADING, loader: state });
// };

export const setSaveLoading = (text?: "Saving changes") => {
  store.dispatch({
    type: SAVING_DESIGN.LOAD,
    saving_text: text,
  });
};

export const changeTemplateLoading = () => {
  store.dispatch({ type: SAVING_DESIGN.LOAD, saving_text: "Changing template..." });
};

export const changeTemplateSuccess = (state?: string) => {
  store.dispatch({
    type: SAVING_DESIGN.SUCCESS,
    save_success_text:
      state === "change_template" ? "Template Changed Successfully!" : "Template Saved Successfully!",
  });
  setTimeout(() => {
    store.dispatch({ type: SAVING_DESIGN.RESET });
  }, 3000);
};

export const changeTemplateFail = (state?: string) => {
  store.dispatch({
    type: SAVING_DESIGN.FAIL,
    save_fail_text: state === "change_template" ? "Template Changed Failed!" : "Template Save Failed!",
  });
  setTimeout(() => {
    store.dispatch({ type: SAVING_DESIGN.RESET });
  }, 3000);
};

export const templateChangeEnable = () => {
  store.dispatch({ type: DESIGN_PREVIEW.TEMPLATE_CHANGE_ENABLE });
};

export const templateChangeDisable = () => {
  store.dispatch({ type: DESIGN_PREVIEW.TEMPLATE_CHANGE_DISABLE });
};

export const designSkeletonLoad = () => {
  store.dispatch({ type: DESIGN.SKELETON_LOAD });
};

export const designSkeletonLoadSuccess = () => {
  store.dispatch({ type: DESIGN.SKELETON_LOAD_SUCCESS });
};

export const confirmWorkflowActiveWarning = (flag: boolean) => {
  store.dispatch({
    type: DESIGN.SET_ACTIVE_WORKFLOW_WARNING,
    payload: flag,
  });
};
